import Svg, {
  Defs,
  FeBlend,
  FeColorMatrix,
  FeComposite,
  FeFlood,
  FeGaussianBlur,
  FeOffset,
  Filter,
  G,
  Path,
  Rect,
} from 'react-native-svg';
import { TIllustrationProps } from './types';

export function IllustrationDesktop({
  width = 86,
  height = 62,
  className,
}: TIllustrationProps) {
  return (
    <Svg
      width={width}
      height={height}
      fill="none"
      className={className}
      viewBox="0 0 86 62"
    >
      <Rect
        width="73.335"
        height="49.813"
        x="6.33"
        y=".032"
        fill="#FF8D78"
        rx="5.573"
      />
      <G filter="url(#illustration-desktop-filter)">
        <Path
          fill="#F2F2F2"
          fillRule="evenodd"
          d="M65.741 42.506c-.275-5.28-2.186-10.5-5.784-14.746-8.402-9.917-22.82-10.753-32.198-1.871-4.688 4.439-7.23 10.462-7.553 16.617H65.74Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#FE7165"
        d="M.5 52.422h85v3.018a5.573 5.573 0 0 1-5.573 5.572H6.073A5.573 5.573 0 0 1 .5 55.44v-3.018Z"
      />
      <Defs>
        <Filter
          id="illustration-desktop-filter"
          width="58.85"
          height="36.082"
          x="16.211"
          y="17.075"
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity="0" result="BackgroundImageFix" />
          <FeColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <FeOffset dx="2.663" dy="3.994" />
          <FeGaussianBlur stdDeviation="3.329" />
          <FeComposite in2="hardAlpha" operator="out" />
          <FeColorMatrix values="0 0 0 0 1 0 0 0 0 0.552941 0 0 0 0 0.470588 0 0 0 0.5 0" />
          <FeBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_770_7223"
          />
          <FeBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_770_7223"
            result="shape"
          />
        </Filter>
      </Defs>
    </Svg>
  );
}
